(ns frontend.ux-overhaul.nev.sub
  (:require
   [reagent.ratom :as ratom]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]))

(defonce new-nev-in-use? (ratom/reaction (:new-nev-in-use? @session/view-config)))







(rf/reg-event-db
 ::editor
 (fn [db _]
   (let [editor (get-in db [:nev :editor])]
     editor)))
